import React from 'react';
import { Button, Form, Modal, Schema, SelectPicker } from 'rsuite';
import { cuotitasStoreService } from '../../../../services';
import { addStorage, alert, asyncService, errorMapper, Field } from '../../../../helpers';
import ENABLE from '../../../../constants/enable';

const body0 = {
    width: '540px',
    padding: '0 4px'
};

const required = 'Este campo es requerido.';
const { StringType } = Schema.Types;
const model = Schema.Model({
    trade: StringType()
    // trade: ObjectType()
        .addRule((value, data) => {
            // TODO add a rule if is necesary
            // if (value !== data.password) {
            //     return false;
            // }
            return true;
        }, 'The two passwords do not match')
        .isRequired(required),
});

export function tradePoliciesStep (context) {
    //
    // Step 2
    //
    const createOfferByPoliticie = () => {
        context.setIsLoading(true);
        const trade = JSON.parse(context.formPoliticies.trade);
        const localContext = {
            data: {
                id: context.formMainUser?.id + '', // TODO idPerson, del getPerson
                idArticle: trade.idArticle + '',
                idCommercePolicy: trade.idCommercePolicy + '',
            },
            errorOfferLoop: null,
            offer: null,
        };

        return asyncService((qss) => cuotitasStoreService.createOffer(context.idStore, localContext.data, qss)) // Original
            .then((response) => {
                // Added extra data for cloudwatch
                const headerExtra = {
                    idLoanOfferLocal: response?.id,
                    IdSolicitudPendiente: response?.id_external
                };
                addStorage('headerExtra', headerExtra);

                localContext.offer = response;
                return context.setOffer(localContext.offer);
            })
            .then(() => getInstallments(localContext))
            .then(() => context.nextStep(3))
            .catch(e => {
                console.error('Error: ', e);
                // console.log('e?.message: ', JSON.parse(e?.message));
                context.setIsAllowContinue(false);
                context.setIsAllowBack(false);

                const msg = errorMapper(e);
                msg.message = `${msg.message}. Cerrar para continuar.`.replace('..', '.').replace('. .', '.');
                e.msg = msg;

                const submitToast = () => context.submitToast(e);
                return alert(msg?.type, msg?.message, 0, 'topCenter', submitToast, onClose);
            })
            .finally(() => context.setIsLoading(false));
    };

    // onClose Alert
    const onClose = () => {
        return context.setIsAllowBack(true);
    };

    // TODO agregar o no async await quizas no para visualizar más rápido el siguiente modal
    const getInstallments = async (localContext) => {
        const idLoanOffer = localContext?.offer?.id;

        return await cuotitasStoreService
            .getInstallmentsByOffer(context.idStore, idLoanOffer)
            .then(response => {
                context.setFormInstallments({
                    ...context.formInstallments,
                    id_loan_offer: response.id || idLoanOffer,
                });
                context.setInstallment(parceInstallment(response));
                context.setInstallmentsExtraData({
                    idsPlan: response.idsPlan || [],
                    assistanceMapping: response.assistanceMapping || [],
                    commercialPlans: response.commercialPlans || []
                });
                context.setAmountLimit({
                    amountMinByPerson: response?.min_amount,
                    amountMaxByPerson: response?.max_amount,
                    amountMinOfInstallments: response?.installmentsInfo?.amountMin,
                    amountMaxOfInstallments: response?.installmentsInfo?.amountMax,
                    installmentAmountMax: response?.metadata?.max_installment_amount
                });

                return response;
            });
    };

    const parceInstallment = (installment) => {
        const installmentsList = installment?.installments;

        return installmentsList?.map(r => {
            return {
                installments: r.installments,
                totalCoefficient: r.totalCoefficient,
                label: r.installments + ' Cuotas de $' + getCuota(context.formInstallments.amount, r.installments, r.totalCoefficient),
                id_loan_offer: context.idLoanOffer || installment.id, // TODO mejorar
                value: ENABLE?.enableInstallmentsWithDate ? JSON.stringify(r) : r.installments,
                firstExpirationDate: r.firstExpirationDate,
            };
        }
        );
    };

    const getCuota = (amount, installment, percentage) => {
        if (amount === 0) return 0;
        return (amount / installment) * percentage;
    };

    const goBack = () => {
        context.setIsAllowContinue(true);
        context.back();
    };

    const submit = () => {
        if (!context.formRef.current.check()) {
            console.error('Form Error');
            return;
        }

        // context.next();
        return createOfferByPoliticie();
    };

    return (
        <>
            <Modal.Body className='mb-5 h-100 py-1' style={{ height: '540px' }}>
                <div className='row m-0' style={body0}>
                    <Form
                        fluid
                        ref={context.formRef}
                        formValue={context.formPoliticies}
                        onChange={context.setFormPoliticies}
                        onCheck={context.setFormErrorPoliticies}
                        model={model}
                    >
                        <div>
                            <Field classNameGroup = 'mb-3' classNameLabel='font-weight-bold' name="trade" label="Política comercial"
                                accepter={SelectPicker}
                                data={context.politicies}
                                style={{ width: '100%' }}
                                // placement="topStart"
                                placeholder="Seleccionar"
                            />
                            {/* salto de linea */}
                            <br />
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div>
                    <Button appearance='subtle' id='back_btn' disabled={context.isLoading || !context.isAllowBack} onClick={() => goBack()} >Atrás</Button>
                    <Button appearance='primary' id='fifth_forward' disabled={context.isLoading || !context.isAllowContinue} onClick={() => submit()} >Siguiente</Button>
                </div>
            </Modal.Footer>
        </>
    );
};
